// extracted by mini-css-extract-plugin
export default {"actions":"ce8931d98f145fd1","action":"_4ecb7ed264bd01e4"};